function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalEdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_50",
    "data-name": "Layer 50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.18 20.7a1.62 1.62 0 0 0 -.41-.76l-17-17a1.52 1.52 0 0 0 -1.06-.44h-21.85a6.07 6.07 0 0 0 -6.07 6.07v46.86a6.07 6.07 0 0 0 6.07 6.07h34.28a6.07 6.07 0 0 0 6.07-6.07v-34.43a1.53 1.53 0 0 0 -.03-.3zm-17-13.08 11.91 11.88h-11.88zm10.96 50.88h-34.28a3.08 3.08 0 0 1 -3.07-3.07v-46.86a3.08 3.08 0 0 1 3.07-3.07h20.35v15.5a1.5 1.5 0 0 0 1.5 1.5h15.5v32.93a3.08 3.08 0 0 1 -3.07 3.07z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 28.3a13.07 13.07 0 1 0 13.06 13.07 13.08 13.08 0 0 0 -13.06-13.07zm9.94 11.57h-5a28.33 28.33 0 0 0 -1.35-7.87 10.09 10.09 0 0 1 6.35 7.87zm-11.84 3h3.8c-.19 4.88-1.28 7.73-1.9 8.44-.62-.71-1.71-3.56-1.9-8.44zm0-3c.19-4.89 1.28-7.74 1.9-8.45.62.71 1.71 3.56 1.9 8.45zm-1.69-7.87a28.33 28.33 0 0 0 -1.3 7.89h-5.05a10.09 10.09 0 0 1 6.35-7.89zm-6.35 10.87h5.05a28.32 28.32 0 0 0 1.3 7.88 10.06 10.06 0 0 1 -6.35-7.88zm13.53 7.88a28.32 28.32 0 0 0 1.3-7.88h5a10.06 10.06 0 0 1 -6.3 7.88z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalEdo);
export default __webpack_public_path__ + "static/media/international_edo.a36ef0aa101da4b7c5c0f937b051324d.svg";
export { ForwardRef as ReactComponent };